import trophy from "../assets/mao_trofeu_w.png";
import { texts } from "../data/langs";
import "../App.css";

export const Achievements = () => {
  return (
    <section className="limiter switch-aspect" id="Conquistas">
      <div className="block switch-text-align">
        <div className="gradTxt">{texts[texts.active].achievements.div}</div>

        <div className="GAP-H20" />

        <h1>{texts[texts.active].achievements.h1}</h1>
        <h3>{texts[texts.active].achievements.h3}</h3>

        <div className="GAP-H20" />
      </div>

      <div className="GAP-20 " />
      <div className="GAP-20 " />

      <div className="block">
        <img src={trophy} className="img_screens" alt="logo" />
      </div>
    </section>
  );
};
